import { Component, Input } from '@angular/core';

@Component({
  selector: 'ct-panel',
  templateUrl: './panel.component.html'
})
export class PanelComponent {
  @Input()
  public header: string;
}
